import { useTranslation } from 'react-i18next';
import OwnerForm from '../../../components/owner/OwnerForm';
import Layout from '../../../components/layouts/Layout';
import { useCurrentOnwer } from '../../../hooks/owner/owner';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import { useSearchParams } from 'react-router-dom';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import DeleteOwnerAccount from '../../../components/owner/DeleteOwnerAccount';

export default function OwnerUpdate() {
  const { t } = useTranslation();
  const {data:owner,isLoading,isError} = useCurrentOnwer();
   const [searchParams] = useSearchParams();
    const category = searchParams.get("category");
  
    const categories = [
      { id: "profile", name: t("profile") },
      { id: "delete_account", name: t("delete_account") },
    ];
  
    const selectedCategory = category ? category : categories[0].id;

    const renderTabContent = () => {
    switch (selectedCategory) {
      case "delete_account":
      return <div>
        <DeleteOwnerAccount/>
      </div>;
      case "profile":
        return <div>
          <LoadingErrorState
          isError={isError}
          isLoading={isLoading}
          />
          {
            owner &&
            <OwnerForm
            successRedirect=""
            submitLabel={t('update')}
            successMessage={t('update_success')}
            defaultValues={{email:owner.email??"",city:owner.city??"",name:owner.name??""}}
          />
          }
        </div>;
      default:
        return <div className="p-4">{t("select_category")}</div>;
    }
  };

  return (
    <Layout title={t('update_information')} headline=''>
      <CategoriesSection
        selectedCategory={selectedCategory}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={"add-offer"}
        buttonLabel="add_new_offer"
        showAdd={false}
        notShowAddButton={true}
        showAllLable={false}
      />

      {/* Tab Content */}
      <div className="mt-6">
        {renderTabContent()}
      </div>
    </Layout>
  );
}
